import { useState, useEffect, useContext, useRef } from 'react'
import axios from 'axios'
import axio from 'axios'
import Swal from 'sweetalert2'
import { projectContext, loadingContext, unfolder, urlValue, openAlert, useTranslate } from '../../lib'
import '../../styles/styles.css'
import '../../styles/wizard.css'
import { Alerts } from '../common/Alerts'
import { validatePrompt } from '../../lib/promptValidator'
import BasicInformation from './BasicInformation'
import ContactDriver from './ContactDriver'
import AIPersonaDetails from './AIPersonaDetails'
import EvaluationFormulary from './EvaluationFormulary'
import CallSettings from './CallSettings'
import VoicesSettings from './VoicesSettings'
import ChatSettings from './ChatSettings'
import SimulationSettings from './SimulationSettings'

export default function ProjectWizardModal({ isModalOpen, closeModal, onClose }) {
  const [loading, setLoading] = useContext(loadingContext)
  const [currentStep, setCurrentStep] = useState(1)
  const [campaings, setCampaings] = useState([])
  const [voices, setVoices] = useState([])
  const [listLanguage, setListLanguage] = useState([])
  const [questions, setQuestions] = useState([
    { id: `${97}-${Date.now()}`, question: "", suggested: "", value: "0", category: "", autofail: 0 },
    { id: `${98}-${Date.now()}`, question: "", suggested: "", value: "0", category: "", autofail: 0 },
    { id: `${99}-${Date.now()}`, question: "", suggested: "", value: "0", category: "", autofail: 0 },
  ])
  const [customEvaluation, setCustomEvaluation] = useState({
    evaluations: [],
    selected_custom_evaluation_id: null,
    grammar_criteria: ["all"]
  });
  const [subCampaings, setSubCampaings] = useState([])
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [error, setError] = useState({ name: "" })
  const [alert, setAlert] = useState({ title: '', visible: false })
  const [customChats, setCustomChats] = useState([
    { id: 0, name: 'Standard' },
    { id: 1, name: 'WhatsApp' },
    { id: 2, name: 'Telegram' },
  ])
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [categoriesApi, setCategoriesApi] = useState([]);
  const [avatarPreview, setAvatarPreview] = useState(null)
  const [avatarFile, setAvatarFile] = useState(null)
  const { t } = useTranslate()
  
  // Form data state
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    language: 'EN-US',
    imageName: "Upload",
    image: null,
    channel: "voice",
    contact_driver_context: '',
    contact_driver_example: '',
    category: 'inbound',
    useValueQuestion: 0,
    industry: 'Other',
    hold: true,
    radomVoice: false,
    personaMood: "friendly",
    personaResponseLength: "short",
    personaTalkativeMood: "yes",
    simulationStatus: 0,
    assistedSimulation: 0,
    azureScenario: 0,
    selectedChatOption: 0,
    showCustomChatForm: false,
    contactDriverForm: false,
    time_hold_amount: 0,
    time_hold: 0,
    minimum_call_durations: 0,
    maximum_call_durations: 0,
    minimum_passing_score: 70,
    closing_msg: '',
    outbound_call_message: '',
    transcription: 1,
    voice_id: null,
    model_sentiment: 'Phrase',
    bot_sentiment: '0',
    campaign_id: null,
    sub_campaign_id: null,
    url_simulation: '',
    steps_simulation: '',
    resolution_time: 0,
    percentage_affectation: 0,
    maxUserResponseTime: 0,
    bot_respose_time: 0,
    gender_bot_avatar: 'male'
  })

  // Refs
  const timeHoldRef = useRef()
  const timeHoldAmountRef = useRef()
  const language = useRef()
  const campaingRef = useRef()
  const subCampaingRef = useRef()
  const name_ref = useRef()
  const description_ref = useRef()
  const url_tp_simulation_ref = useRef()
  const campaign_ref = useRef()
  const subcampaing_ref = useRef()
  const voice_ref = useRef()
  const welcome_mesage_ref = useRef()
  const minimunCallDurations = useRef()
  const maximunCallDurations = useRef()
  const maxUserResponseTime = useRef()
  const bot_respose_time_ref = useRef()
  const Simulation_Step_number_ref = useRef()
  const minimum_passing_score_ref = useRef()
  const sentimentBotRef = useRef()
  const modelSentiment_ref = useRef()
  const resolution_time_ref = useRef()
  const percentage_affectation_ref = useRef()  

  const refs = {
    timeHoldRef,
    timeHoldAmountRef,
    language,
    campaingRef,
    subCampaingRef,
    name_ref,
    description_ref,
    url_tp_simulation_ref,
    campaign_ref,
    subcampaing_ref,
    voice_ref,
    welcome_mesage_ref,
    minimunCallDurations,
    maximunCallDurations,
    maxUserResponseTime,
    bot_respose_time_ref,
    Simulation_Step_number_ref,
    minimum_passing_score_ref,
    sentimentBotRef,
    modelSentiment_ref,
    resolution_time_ref,
    percentage_affectation_ref
  }

  const fetchCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    try {
      const url = `${urlValue}/studio/campaign/campaignsUser`
      // const url = `${urlValue}/studio/campaign/subcampaignsUser`
      const rest = await axio.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      })

      if (rest.status === 200 && rest.data) {
        setCampaings(rest.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchVoice = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    try {
      const url = `${urlValue}/studio/project/voices/all`
      const rest = await axio.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
          language: language?.current?.value.substring(0, 2) || 'EN',
          'project_id': 0
        },
      })

      if (rest.status === 200 && rest.data) {
        setVoices(rest.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchLanguage = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    try {
      const url = `${urlValue}/studio/language`
      const rest = await axio.get(url, {
        headers: {
          'access-token': token,
          'Content-Type': 'application/json',
        },
      })

      if (rest.status === 200 && rest.data) {
        setListLanguage(rest.data.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchSubCampaing = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    try {
      const url = `${urlValue}/studio/campaign/subcampaignsUser`
      const rest = await axio.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
        },
      })

      if (rest.status === 200 && rest.data) {
        setSubCampaings(rest.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchCustomChats = async () => {
    const predefined = [
      { id: 0, name: 'Standard' },
      { id: 1, name: 'WhatsApp' },
      { id: 2, name: 'Telegram' },
    ]

    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    try {
      const url = `${urlValue}/studio/project/customchats/all`

      const rest = await axios.get(url, {
        headers: {
          user: id,
          'access-token': token,
          'Content-Type': 'application/json',
          'project_id': 0
        },
      })

      if (rest.status === 200 && rest.data.data) {
        setCustomChats([...predefined, ...rest.data.data])
      }
      return rest.data.data
    } catch (error) {
      setCustomChats(predefined)
      console.log(error)
      return error
    }
  }

  const fetchCategories = async () => {
    setLoadingCategories(true);
    try {
      let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
      let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
      let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken

      const response = await axios({
        method: 'get',
        url: `${urlValue}/studio/categories`,
        headers: {
          'access-token': token,
          user: id,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
      });
      setCategoriesApi(response.data || []);
    } catch (err) {
      setCategoriesApi([]);
      console.log('Error fetching categories:', err);
    }
    setLoadingCategories(false);
  };
    

  useEffect(() => {
    fetchCampaing()
    fetchSubCampaing()
    fetchLanguage()
    fetchVoice()
    fetchCustomChats()
    fetchCategories();
  }, [])

  const convertToBase64 = (file) => {
    return new Promise(resolve => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        resolve(reader.result)
      }
    })
  }

  const containsEmoji = (str) => {
    if (!str) return false

    try {
      const re = /(\p{Emoji_Presentation}|\p{Extended_Pictographic})/u
      return re.test(str)
    } catch (e) {
      const fallback = /[\uD800-\uDBFF][\uDC00-\uDFFF]/
      return fallback.test(str)
    }
  }

  const createProject = async () => {
    let ok = true
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id

    let convertedFile = ""
    if (formData.image) {
      convertedFile = await convertToBase64(formData.image)
    }

    const aiPersonaDetails = {
      mood: formData.personaMood,
      responseLength: formData.personaResponseLength,
      talkativeMood: formData.personaTalkativeMood
    }

    if (ok) {
      const dataSend = {
        name: formData.name,
        nlp: 1,
        nlp_config: {},
        nlp_url: 'localhost',
        metadata: { "description": formData.description, "language": formData.language },
        image: { "imageName": formData.imageName, "url": "" } || null,
        imageFile: convertedFile || null,
        time_hold_amount: formData.time_hold_amount || 0,
        time_hold_seconds: formData.time_hold || 0,
        use_hold: formData.hold ? 1 : 0,
        campaing: formData.campaign_id,
        sub_campaing: formData.sub_campaign_id,
        voice: formData.voice_id || 0,
        random_voice: formData.radomVoice ? 1 : 0,
        type: "GEN AI",
        channel: formData.channel,
        transcription: formData.transcription,
        contact_driver_context: formData.contact_driver_context,
        contact_driver_example: formData.contact_driver_example,
        contact_driver_config: aiPersonaDetails,
        use_value_question: formData.useValueQuestion,
        evaluation_questions: questions,
        industry: (customEvaluation.selected_custom_evaluation_id && customEvaluation.selected_custom_evaluation_id > 0) 
            ? 'Custom' 
            : formData.industry,
        custom_evaluation: customEvaluation.evaluations.length > 0 ? {
            evaluations: customEvaluation.evaluations,
            selected_custom_evaluation_id: customEvaluation.selected_custom_evaluation_id
        } : null,
        grammar_criteria: Array.isArray(customEvaluation.grammar_criteria) 
            ? customEvaluation.grammar_criteria.join(',') 
            : customEvaluation.grammar_criteria,
        url_tp_simulation: formData.url_simulation,
        simulation_status: formData.simulationStatus,
        num_simulation_steps: formData.steps_simulation,
        assisted_simulation: formData.assistedSimulation,
        azure_scenario: formData.azureScenario,
        custom_chat: formData.selectedChatOption,
        minimum_passing_score: formData.minimum_passing_score || 70,
        bot_sentiment: formData.bot_sentiment,
        model_sentiment: formData.model_sentiment,
        category: formData.category,
        outbound_call: formData.category === 'outbound' ? 1 : 0,
        welcome_msg: formData.outbound_call_message,
        min_call_time: formData.minimum_call_durations || 0,
        max_call_time: formData.maximum_call_durations || 0,
        closing_msg: formData.closing_msg,
        max_user_response_time: formData.maxUserResponseTime,
        bot_response_time: formData.bot_respose_time || 0,
        affectation_time: formData.resolution_time,
        percentage_affectation: formData.percentage_affectation,
        gender_bot_avatar: formData.gender_bot_avatar,
        use_new_prompt: 1
      }
      
      axios({
        method: 'post',
        url: `${urlValue}/studio/project`,
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true,
        data: dataSend,
      })
        .then(function (response) {
          openAlert('#alert-ac', () => { setAlert({ title: t('alerts.projectSaved'), visible: true, error: false }) }, 4000, () => { setAlert({ ...alert, visible: false }) })
          onClose()
          setLoading(false)
          window.location.reload()
        })
        .catch(function (error) {
          let message = t('alerts.projectNotSaved')
          if (error.response.status == 401) {
            message = error.response.data.message
          }
          openAlert('#alert-ac', () => { setAlert({ title: message, visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) })
          console.log(error)
          setLoading(false)
        })
    }
  }

  const validateBasicInformation = async () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    let ok = true
    const exp = /^[A-Za-z0-9-,._'¿?\s]+$/g
    if (!exp.test(name_ref.current?.value)) {
      ok = false
      openAlert(
        '#alert-ac',
        () => setAlert({ title: t('errors.nameInvalid'), visible: true, error: true }),
        4000,
        () => setAlert({ ...alert, visible: false })
      )
    }

    //Valida que el nombre del proyecto no exista
    if ((name_ref.current?.value || '') !== '' && ok){
      await axios({
        method: 'get',
        url: `${urlValue}/studio/project/validatename/${name_ref.current?.value}`,
        headers: {
          user: id,
          'access-token': token,
          'X-CSRF-Token': csrfToken
        },
        withCredentials: true
      })
        .then(function (response) {
          if (!response.data) {
            openAlert('#alert-ac', () => { setAlert({ title: t('alerts.projectExists'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) })
            ok = false
          }        
        })
        .catch(function (error) {
          openAlert('#alert-ac', () => { setAlert({ title: t('alerts.errorConsultProjectName'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) })
        })

    }

    if ((description_ref.current?.value || '') === '' && ok){
      openAlert('#alert-ac', () => { setAlert({ title: t('alerts.descriptionEmpty'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) })
      ok = false
    }
    return ok
  }

  const validateContactDriver = async () => {
    let ok = true
    if ((formData.contact_driver_context || '') === '' ){
      openAlert('#alert-ac', () => { setAlert({ title: t('alerts.contextEmpty'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) })
      ok = false
    }

    const emojiContext = containsEmoji(formData.contact_driver_context)
    const emojiExample = containsEmoji(formData.contact_driver_example)

    if (emojiContext || emojiExample) {
      ok = false
      openAlert(
        '#alert-ac',
        () => setAlert({ title: t('alerts.validateEmoji'), visible: true, error: true }),
        4000,
        () => setAlert({ ...alert, visible: false })
      )
    }

    return ok
  }

  const validateEvaluationFormulary = async () => {
    let ok = true
    let valueTotal = 0
    if (formData.useValueQuestion == 1) {
      for (let i = 0; i < questions.length; i++) {
        if ((parseFloat(questions[i].value) || 0) <= 0) {
          ok = false;
          openAlert('#alert-ac', () => {setAlert({title: t('alerts.valueQuestions'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
          break;
        }
        valueTotal = valueTotal + parseFloat(questions[i].value)
      }

      if (valueTotal != 100) {
        ok = false;
        openAlert('#alert-ac', () => {setAlert({title: t('alerts.totalValueQuestions'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
      }
    }

    const invalidQuestions = questions.filter((q) => q.question.includes('"'));
    if (invalidQuestions.length > 0) {
      ok = false;
      openAlert('#alert-ac', () => { setAlert({ title: t('alerts.doubleQuotesQuestions'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
    }

    const countAutofail = questions.filter(q => q.autofail === 1).length;
    if (countAutofail > 1) {
      ok = false;
      openAlert('#alert-ac', () => { setAlert({ title: ('alerts.validateAutoFail'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
    }

    return ok
  }

  const validateCallSttings = async () => {
    let ok = true
    if ((formData?.campaign_id || null) == null || (formData?.sub_campaign_id || null) == null) {
      ok = false;
      openAlert('#alert-ac', () => {setAlert({title: t('alerts.selectCampaignSubcampaign'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
    }
    return ok
  }

  const validateVoiceStting = async () => {
    let ok = true

    if ((formData?.voice_id || null) == null) {
      ok = false;
      openAlert('#alert-ac', () => {setAlert({title: t('alerts.validateSelectVoice'), visible: true, error: true})}, 4000, ()=>{setAlert({...alert,visible: false})} );
    }
    
    const minCallTime = Number(minimunCallDurations.current?.value || 0)
    const maxCallTime = Number(maximunCallDurations.current?.value || 0)
    if (minCallTime > maxCallTime) {
      ok = false
      openAlert(
        '#alert-ac',
        () => setAlert({ title: t('alerts.valideMaxAndMinCall'), visible: true, error: true }),
        4000,
        () => setAlert({ ...alert, visible: false })
      )
    }

    return ok
  }

  const selectStep = (step) => {
    if (currentStep > step) {
      setCurrentStep(step)
    }
  }

  const nextStep = async () => {
    let validation = true
    if (currentStep == 1) {
      validation = await validateBasicInformation()
    }
    else if (currentStep == 2) {
      validation = await validateContactDriver()
    }
    else if (currentStep == 4) {
      validation = await validateEvaluationFormulary()
    }
    else if (currentStep == 5) {
      validation = await validateCallSttings()
    }
    else if (currentStep == 6 && formData.channel === 'voice') {
      validation = await validateVoiceStting()
    }

    if (currentStep < 7 && validation) {
      setCurrentStep(currentStep + 1)
    }
  }

  const prevStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1)
    }
  }

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <BasicInformation 
          formData={formData} 
          setFormData={setFormData} 
          refs={refs}
          listLanguage={listLanguage}
          fetchVoice={fetchVoice}
        />
      case 2:
        return <ContactDriver 
          formData={formData} 
          setFormData={setFormData} 
          refs={refs}
        />
      case 3:
        return <AIPersonaDetails
          formData={formData}
          setFormData={setFormData}
        />
      case 4:
        return <EvaluationFormulary
          questions={questions}
          formData={formData}
          setFormData={setFormData}
          setQuestions={setQuestions}
          loadingCategories={loadingCategories}
          categoriesApi={categoriesApi}
          customEvaluation={customEvaluation}
          setCustomEvaluation={setCustomEvaluation}
        />
      case 5:
        return <CallSettings
          formData={formData}
          setFormData={setFormData}
          refs={refs}
          campaings={campaings}
          subCampaings={subCampaings}
          avatarPreview={avatarPreview}
          setAvatarPreview={setAvatarPreview}
          setAvatarFile={setAvatarFile}
        />
      case 6:
        return formData.channel === 'voice' ? (
          <VoicesSettings
            formData={formData}
            setFormData={setFormData}
            refs={refs}
            voices={voices}
            setAlert={setAlert}
          />
        ) : (
          <ChatSettings
            formData={formData}
            setFormData={setFormData}
            refs={refs}
            customChats={customChats}
            fetchCustomChats={fetchCustomChats}
          />
        )
      case 7:
        return <SimulationSettings
          formData={formData}
          setFormData={setFormData}
          refs={refs}
        />
      default:
        return null
    }
  }

  return (
    <div className="newProject-modal modal-cont">
      <h1>{t('menu.createProject')} - {t('menu.wizard')}</h1>

      {/* Wizard Progress Indicator */}
      <div className="wizard-progress" style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
        <div className={`wizard-step-indicator ${currentStep >= 1 ? 'active' : ''}`} 
          style={{ cursor: currentStep > 1 ? "pointer" : "default" }} onClick={() => selectStep(1)}>
          <span className="step-number">1</span>
          <span className="step-label">{t('menu.genai.basicInformation')}</span>
        </div>
        <div className="wizard-line" style={{ borderTop: '2px solid #ccc', width: '80px', alignSelf: 'center' }}></div>
        <div className={`wizard-step-indicator ${currentStep >= 2 ? 'active' : ''}`}
          style={{ cursor: currentStep > 2 ? "pointer" : "default" }} onClick={() => selectStep(2)}>
          <span className="step-number">2</span>
          <span className="step-label">{t('menu.genai.contactDriver')}</span>
        </div>
        <div className="wizard-line" style={{ borderTop: '2px solid #ccc', width: '80px', alignSelf: 'center' }}></div>
        <div className={`wizard-step-indicator ${currentStep >= 3 ? 'active' : ''}`}
          style={{ cursor: currentStep > 3 ? "pointer" : "default" }} onClick={() => selectStep(3)}>
          <span className="step-number">3</span>
          <span className="step-label">AI Persona</span>
        </div>
        <div className="wizard-line" style={{ borderTop: '2px solid #ccc', width: '80px', alignSelf: 'center' }}></div>
        <div className={`wizard-step-indicator ${currentStep >= 4 ? 'active' : ''}`}
          style={{ cursor: currentStep > 4 ? "pointer" : "default" }} onClick={() => selectStep(4)}>
          <span className="step-number">4</span>
          <span className="step-label">{t('menu.genai.evaluationFormulary')}</span>
        </div>
        <div className="wizard-line" style={{ borderTop: '2px solid #ccc', width: '80px', alignSelf: 'center' }}></div>
        <div className={`wizard-step-indicator ${currentStep >= 5 ? 'active' : ''}`}
          style={{ cursor: currentStep > 5 ? "pointer" : "default" }} onClick={() => selectStep(5)}>
          <span className="step-number">5</span>
          <span className="step-label">{t('menu.genai.callSettings')}</span>
        </div>
        <div className="wizard-line" style={{ borderTop: '2px solid #ccc', width: '80px', alignSelf: 'center' }}></div>
        <div className={`wizard-step-indicator ${currentStep >= 6 ? 'active' : ''}`}
          style={{ cursor: currentStep > 6 ? "pointer" : "default" }} onClick={() => selectStep(6)}>
          <span className="step-number">6</span>
          <span className="step-label">{formData.channel === 'voice' ? t('menu.genai.voicesSettings') : t('menu.genai.chatSettings')}</span>
        </div>
        <div className="wizard-line" style={{ borderTop: '2px solid #ccc', width: '80px', alignSelf: 'center' }}></div>
        <div className={`wizard-step-indicator ${currentStep >= 7 ? 'active' : ''}`}
          style={{ cursor: currentStep > 7 ? "pointer" : "default" }} onClick={() => selectStep(7)}>
          <span className="step-number">7</span>
          <span className="step-label">{t('menu.genai.simulationSettings')}</span>
        </div>
      </div>

      <form className="w-100">
        <div className="scroll-gen-modal sm7-h-50vh sm6-h-50vh sm5-h-70vh sm4-h-70vh sm3-h-70vh h-80">
          {renderStep()}

          <div className="footer" style={{ marginTop: 30 }}>
            <div className='cont-buttons'>
              <span className='errors-msg'>{error.name}</span>
            </div>
          </div>
        </div>

        <div className='cont-buttons' style={{
          paddingRight: 20,
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: 12
        }}>
          <div className="buttons flex items-center" style={{ marginBottom: 20 }}>
            <button 
              className="cancel btn-bottom btn-bottom-cancel" 
              type="button" 
              style={{ marginRight: 10, color: 'white' }} 
              onClick={() => onClose()}
            >
              {t('common.cancel')}
            </button>

            {currentStep > 1 && (
              <button 
                className="btn-bottom btn-bottom-cancel" 
                type="button" 
                style={{ marginRight: 10, color: 'white' }} 
                onClick={prevStep}
              >
                {t('common.previous')}
              </button>
            )}
            
            {currentStep < 7 ? (
              <button 
                className="create btn-bottom btn-bottom-create" 
                type="button" 
                style={{ color: 'white' }} 
                onClick={nextStep}
              >
                {t('common.next')}
              </button>
            ) : (
              <button 
                className="create btn-bottom btn-bottom-create" 
                type="button" 
                style={{ color: 'white' }} 
                onClick={() => createProject()}
              >
                {t('common.create')}
              </button>
            )}
          </div>
        </div>
      </form>
      {alert.visible && <Alerts id="alert-ac" title={alert.title} error={alert.error} />}
    </div>
  )
}
